import { useState } from "react"

export const useDefaultSortAction = (sort, sorts, setSort) => {
  const [showItems, setShowItems] = useState(false)
  const toShow = sort || sorts[0].title
  const orientation =
    sort === "createddesc" || sort === "titledesc" || sort === "namedesc"
      ? "desc"
      : ""
  sort = sort || toShow
  const [sortType, setSortType] = useState(orientation) // ;; => asc | desc
  const toggleItems = () => setShowItems(!showItems)
  const onChangeSortType = () => {
    sort = sort.toLowerCase().replace("desc", "")
    const _sortType = sortType === "" ? "desc" : ""
    setSortType(_sortType)
    setSort(`${sort}${_sortType}`)
  }

  const sanatize = (str) =>
    (str.charAt(0).toUpperCase() + str.slice(1)).replace("desc", "")
  const _sorts = sorts.filter((_sort) => _sort.title !== toShow)

  return {
    showItems,
    setShowItems,
    toggleItems,
    sortType,
    onChangeSortType,
    toShow,
    sanatize,
    _sorts,
  }
}
